import { render, staticRenderFns } from "./InternationalMapMobile.vue?vue&type=template&id=0b350076&scoped=true&"
import script from "./InternationalMapMobile.vue?vue&type=script&lang=js&"
export * from "./InternationalMapMobile.vue?vue&type=script&lang=js&"
import style0 from "./InternationalMapMobile.vue?vue&type=style&index=0&id=0b350076&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b350076",
  null
  
)

export default component.exports